import { widgetDecorationPluginKey } from './plugin';
export const removeDecoration = (tr, id) => {
    const meta = {
        type: 'remove',
        id,
    };
    return tr.setMeta(widgetDecorationPluginKey, meta);
};
